export type ReadAlongEpisode = {
  title: string;
  seriesTitle: string;
  imgSrc: string;
  videoSrc: string;
  duration: string;
  loggingId: string;
};

export const episodes: ReadAlongEpisode[] = [
  {
    title: "Unicorn (and Horse)",
    seriesTitle: "Vooks",
    imgSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_unicorn_and_horse_thumbnail.jpg",
    videoSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_unicorn_and_horse.mp4",
    duration: "6",
    loggingId: "vooks_unicorn_and_horse",
  },
  {
    title: "Courageous People Who Changed the World",
    seriesTitle: "Vooks",
    imgSrc:
      "https://static.classdojo.com/toolkit-static/read_alongs/vooks_courageous_people_who_changed_the_world_thumbnail.jpg",
    videoSrc:
      "https://static.classdojo.com/toolkit-static/read_alongs/vooks_courageous_people_who_changed_the_world.mp4",
    duration: "9",
    loggingId: "vooks_courageous_people",
  },
  {
    title: "Nom Nom Colors",
    seriesTitle: "Vooks",
    imgSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_nom_nom_colors_thumbnail.jpg",
    videoSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_nom_nom_colors.mp4",
    duration: "7",
    loggingId: "vooks_nom_nom_colors",
  },
  {
    title: "Inventors Who Changed the World",
    seriesTitle: "Vooks",
    imgSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_inventors_thumbnail.jpg",
    videoSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_inventors_who_changed_the_world.mp4",
    duration: "9",
    loggingId: "vooks_inventors",
  },
  {
    title: "Opposites",
    seriesTitle: "Vooks",
    imgSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_opposites_thumbnail.jpg",
    videoSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_opposites.mp4",
    duration: "4",
    loggingId: "vooks_opposites",
  },
  {
    title: "But First, We Nap",
    seriesTitle: "Vooks",
    imgSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_but_first_we_nap_thumbnail.jpg",
    videoSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_but_first_we_nap.mp4",
    duration: "4",
    loggingId: "vooks_but_first_we_nap",
  },
  {
    title: "The Day Punctuation Came to Town",
    seriesTitle: "Vooks",
    imgSrc:
      "https://static.classdojo.com/toolkit-static/read_alongs/vooks_the_day_punctuation_came_to_town_thumbnail.jpg",
    videoSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_the_day_punctuation_came_to_town.mp4",
    duration: "7",
    loggingId: "vooks_the_day_punctuation",
  },
  {
    title: "Cinderella",
    seriesTitle: "Vooks",
    imgSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_cinderella_thumbnail.jpg",
    videoSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_cinderella.mp4",
    duration: "5",
    loggingId: "vooks_cinderella",
  },
  {
    title: "Animal Alphabet",
    seriesTitle: "Vooks",
    imgSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_animal_alphabet_thumbnail.jpg",
    videoSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_animal_alphabet.mp4",
    duration: "3",
    loggingId: "vooks_animal_alphabet",
  },
  {
    title: "Luis and Tabitha",
    seriesTitle: "Vooks",
    imgSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_luis_and_tabitha_thumbnail.jpg",
    videoSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_luis_and_tabitha.mp4",
    duration: "9",
    loggingId: "vooks_luis_and_tabitha",
  },
  {
    title: "The Mitten",
    seriesTitle: "Vooks",
    imgSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_the_mitten_thumbnail.jpg",
    videoSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_the_mitten.mp4",
    duration: "7",
    loggingId: "vooks_the_mitten",
  },
  {
    title: "The Very Cold, Freezing, No-Number Day",
    seriesTitle: "Vooks",
    imgSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_very_cold_freezing_thumbnail.jpg",
    videoSrc: "https://static.classdojo.com/toolkit-static/read_alongs/vooks_very_cold_freezing.mp4",
    duration: "5",
    loggingId: "vooks_very_cold_freezing",
  },
];
